export async function verifyHwaToken(token) {
    const res = await fetch('vendor/VerifyToken/hwa', {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({
            token: token
        })
    });

    if (res.ok) {
        const result = await res.json();
        return result.success;
    }

    return false;
}

export async function getHwaRedirectUrl() {
    const res = await fetch('api/helper/GetHwaRedirectUrl');
    const data = await res.json();
    return data.redirectUrl;
}

export function updatePartnerCase(claimNumber, status, clientId) {
    var route = 'vendor/apple/partnercaseupdate/';
    var finalRoute = route
        .concat(claimNumber)
        .concat('/' + status)
        .concat('/' + clientId);
    fetch(finalRoute, {
        method: 'post'
    }).then((res) => {
        if (res.ok) {
            console.log('happy');
        }
    });
}

export function createRepair(clientId, claimNumber) {
    var route = 'vendor/apple/repair/';
    var finalRoute = route.concat(clientId).concat('/' + claimNumber);

    return fetch(finalRoute, {
        method: 'post'
    });
}

export function updateRepair(clientId, claimNumber, status) {
    var route = 'vendor/apple/repair/update/';
    var finalRoute = route.concat(claimNumber).concat('/' + clientId + '/' + status);
    return fetch(finalRoute, {
        method: 'post'
    });
}

export function cancelClaim(clientId, claimNumber) {
    var route = 'api/claim/CancelClaim/';
    var finalRoute = route.concat(clientId).concat('/' + claimNumber);
    fetch(finalRoute, {
        method: 'post'
    }).then((res) => {
        if (res.ok) {
            console.log('Cancel Claim - Success');
        }
    });
}

export function getStatusColor(statusName) {
    return statusName;
}

export async function getTUToken(clientId) {
    var route = 'vendor/transunion/GetToken/';
    var finalRoute = route.concat(clientId).concat('/');
    return await fetch(finalRoute);
}

export async function getTUSessionId(clientId) {
    var route = 'vendor/transunion/GetSessionId/';
    var finalRoute = route.concat(clientId).concat('/');
    return await fetch(finalRoute);
}

export async function addTUCase(token, model) {
    var route = 'vendor/transunion/AddCase/';
    var finalRoute = route.concat(token).concat('/');
    console.log(model, JSON.stringify({ model }));
    return await fetch(finalRoute, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            PartyId: model.PartyId.toString(),
            Addresses: model.Addresses,
            Phone: model.Phone,
            FirstName: model.FirstName,
            LastName: model.LastName,
            EmailAddress: model.EmailAddress,
            ClaimNumber: model.ClaimNumber,
            ClaimId: model.ClaimId,
            Token: token,
            SessionId: model.SessionId,
            ClientId: model.ClientId
        })
    });
}

export async function getTranslation(path, language) {
    var route = 'api/dynamicContent/text';
    return await fetch(route, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            Path: path,
            //language is currently not used, may be used in later stories
            Language: language
        })
    });
}

export async function getFormatting(path, country) {
    var route = 'api/dynamicContent/format';
    return await fetch(route, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            Path: path,
            //country is currently not used, may be used in later stories
            Country: country
        })
    });
}

export async function getTUDetailedDecision(token, caseId, clientId, claimId) {
    var route = 'vendor/transunion/GetDecision/';
    var finalRoute = route.concat(token).concat('/' + caseId + '/' + claimId + '/' + clientId);
    return await fetch(finalRoute);
}

export function sendEmail(
    clientId,
    emailType,
    customerName,
    phone,
    caseNumber,
    model,
    caseDate,
    url,
    address,
    claimNumber,
    claimSetupDate,
    serialNumber,
    claimId,
    servicer,
    servicerPhone,
    appointmentDate,
    appointmentWindow,
    clientContractNumber,
    fee,
    assetName = ''
) {
    console.log(
        clientId,
        customerName,
        phone,
        caseNumber,
        model,
        caseDate,
        url,
        address,
        claimNumber,
        claimSetupDate,
        serialNumber,
        servicer,
        servicerPhone,
        appointmentDate,
        appointmentWindow,
        clientContractNumber,
        fee,
        assetName
    );
    // Send Approved Mail
    return fetch('api/communication/'.concat(clientId), {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            emailModel: {
                Recipients: [address],
                Cc: [],
                Bcc: [],
                IsBodyHtml: true,
                emailType: emailType // Int
            },
            serviceModel: {
                ClaimNumber: claimNumber,
                ConsumerName: customerName,
                SubscriberName: customerName, // First Name + Last Name
                MiniSiteURL: url, // '<a href="https://www.aigtheftandloss.com">www.aigtheftandloss.com</a>'
                WirelessNumber: phone, //this.props.party.partyPhoneModel[0].number
                DeviceMakeandModel: model, //this.props.contract.contractAssetModel[0].modelNumber
                CaseNumber: caseNumber, //this.props.clientClaimNumber
                CaseNumberDate: caseDate, //moment(this.props.claimIncidentDate).format("MM/DD/YYYY")
                ClaimSetupDate: claimSetupDate,
                SerialNumber: serialNumber,
                ClaimId: claimId,
                ClientContractNumber: clientContractNumber,
                Fee: fee,
                Servicer: servicer,
                ServicerPhone: servicerPhone,
                AppointmentDate: appointmentDate,
                AppointmentWindow: appointmentWindow,
                AssetName: assetName
            }
        })
    }).then(function (res) {
        console.log(res);
        let statusCode = res.status;
        return res.json();
    });
}

export async function addTUStatus(claimNumber, token, caseId, status, clientId) {
    var route = 'vendor/transunion/AddStatus/';
    var finalRoute = route.concat(clientId);

    return await fetch(finalRoute, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            Token: token,
            CaseId: caseId,
            ClaimNumber: claimNumber,
            AddStatusRequest: {
                Comment: '',
                Id: caseId,
                Status: status
            }
        })
    });
}

export async function getTUCaseId(claimNumber, clientId) {
    var route = 'vendor/transunion/GetCaseId/';
    var finalRoute = route.concat(claimNumber).concat('/' + clientId);
    return await fetch(finalRoute);
}

export async function createNewAuthorization(
    claimId,
    billingCode,
    status,
    clientId,
    quantity = 1,
    createdBy = 'SalesPortal',
    adjuster = ''
) {
    var route = `api/authorization/${clientId}`;
    return await fetch(route, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ClaimId: claimId,
            BillingCode: billingCode,
            AuthorizedQuantity: quantity,
            AuthorizationStatus: status,
            Adjuster: adjuster,
            CreatedBy: createdBy
        })
    });
}

export async function updateClaimConfiguration(claimId, attributeId, value, clientId) {
    var route = 'api/claim/UpdateClaimConfigurationAttributeValue/';
    var finalRoute = route.concat(clientId);
    return await fetch(finalRoute, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            claimId: claimId,
            claimAttributeId: attributeId,
            Value: value
        })
    });
}

export function updateSymptomClaim(clientId, claimId, symptom) {
    var route = 'api/claim/updatesymptom/';
    var finalRoute = route.concat(claimId).concat('/' + clientId + '/' + symptom);
    return fetch(finalRoute, {
        method: 'put'
    });
}

export function addAnswerCollection(clientId, claimId, questionSetMappingId, answerText, answerId, questionId) {
    var route = 'api/troubleshooting/AddAnswerCollection/';
    var finalRoute = route.concat(clientId);
    return fetch(finalRoute, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            warrantyObjectTypeId: 2,
            warrantyObjectValue: claimId,
            questionSetMappingId: questionSetMappingId,
            answerId: answerId,
            alternateAnswerText: answerText,
            questionId: questionId
        })
    });
}

export async function fetchPaymentSession(validationUrl) {
    //console.log(validationUrl);
    //var route = "vendor/ApplePay/GetPaymentSession/";
    var route = 'vendor/ApplePay/PaymentSession/';
    var finalRoute = route.concat('apple');
    let session = 0;
    //console.log(finalRoute);
    //let response = await fetch(finalRoute)
    let response = await fetch(finalRoute, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            url: validationUrl
        })
    })
        .then(function (res) {
            //console.log(res, res.json);
            session = res.status;
            return res.json();
        })
        .then((data) => {
            if (session === 200) {
                //console.log(data);
                return data;
            }
        });

    //console.log(response);
    return response;
}

export async function processResponse(promise) {
    try {
        let response = await promise;
        console.log(promise, response);
        let status = response.merchantSessionIdentifier;
    } catch (Exception) {
        return 0;
    }
}

export function getDenialReason(rulesetDetailId) {
    // changes to these reasons should also be applied to the denied section in confirmation.jsx
    switch (rulesetDetailId) {
        case 1:
        case 7:
            return 'This plan is not active; therefore, we cannot proceed with filing a new claim at this time.';
        case 2:
        case 6:
        case 8:
            return 'This product is not eligible for service because coverage has not started. The coverage start date cannot be in the future.';
        case 13:
            return 'This product is not eligible for service due to the plan’s claim limit already being met.';
        case 3:
        case 9:
            return 'This product is not yet eligible for service due to the product currently being covered by the manufacturer’s warranty. The plan’s coverage will begin after the manufacturer’s warranty expires. Please contact the manufacturer to service your product.';

        case 4:
        case 10:
        case 11:
            return 'This product is not eligible for service due to the incident date is prior to the contract begin date.';

        case 12:
            return 'Incident must be a covered issue. This incident is not eligible for service due to not being covered under your current plan';
        default:
            return null;
    }
}

export const dataLayerPush = (event = 'Pageview', data = {}) => {
    const isAgentEntry = JSON.parse(sessionStorage.getItem('isAgentEntry'));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event,
        isAgentEntry: !!isAgentEntry,
        ...data
    });
};

export function resumeClaim(col, client, propsGlobal) {
    /* TODO */

    // Add spinner, pull claim information and open claim in saved step
    console.log(col);
    let savedStep = col.savedStep;
    let assetId = col.contractAssetId;
    let claimId = col.claimId;
    let contractId = col.contractId;
    let coverageId = col.coverageId;
    let pathName = `/fileclaim/entitlement/${assetId}/${claimId}/${contractId}/${coverageId}`;
    let history = { pathname: pathName };
    let setupDate = Date(col.claimSetupDate).toISOString; //prevents errors about translating to nullable datetime
    let completionDate = Date(col.claimFileCompletionDate).toISOString;
    col.claimFileCompletionDate = completionDate;
    col.claimSetupDate = setupDate;
    let entitlementDetails = {
        ammount: null,
        clientId: client,
        claimNumber: col.claimNumber,
        caseNumber: null,
        deductible: col.tcf,
        caseNumber: null,
        symptom: col.symptom,
        contract: col.contract,
        party: col.partyModel,
        address1: col.partyModel.serviceAddress?.address1,
        address2: col.partyModel.serviceAddress?.address2,
        city: col.partyModel.serviceAddress?.city,
        state: col.partyModel.serviceAddress?.state,
        stateId: col.partyModel.serviceAddress?.stateId,
        zip: col.partyModel.serviceAddress?.zip,
        contractAsset: col.contract?.contractAssetModel?.find((ca) => ca.contractAssetId == assetId),
        assetId: col.contract?.contractAssetModel?.find((ca) => ca.contractAssetId == assetId)?.assetId ?? 0
    };

    switch (savedStep) {
        case '1':
            // Entitlement page, need to figure out which symptom and part of the process
            pathName = `/fileclaim/entitlement/${assetId}/${claimId}/${contractId}/${coverageId}`;
            return (history = {
                pathname: pathName,
                claim: col,
                clientId: client,
                stepsCounter: col.stepsCounter,
                state: { entitlementDetails: entitlementDetails, claim: col }
            });
        case '3':
            // Payment page
            pathName = `/fileclaim/entitlement/${assetId}/${claimId}/${contractId}/${coverageId}`;
            return (history = {
                pathname: pathName,
                claim: col,
                clientId: client,
                stepsCounter: col.stepsCounter,
                isPaymentActive: true,
                // Add entitlement details to state
                state: { entitlementDetails: entitlementDetails, claim: col }
            });
        case '2':
            // Verify info
            pathName = `/fileclaim/entitlement/${assetId}/${claimId}/${contractId}/${coverageId}`;
            return (history = {
                pathname: pathName,
                claim: col,
                clientId: client,
                state: { entitlementDetails: entitlementDetails, claim: col }
            });
        case '4':
            // Upload docs, not supported
            pathName = `/fileclaim/entitlement/${assetId}/${claimId}/${contractId}/${coverageId}`;
            return (history = {
                pathname: pathName,
                claim: col,
                clientId: client,
                state: { entitlementDetails: entitlementDetails, claim: col }
            });
        case '5':
            // Appointment
            pathName = '/appointment';
            return (history = {
                pathname: pathName,
                claim: col,
                clientId: client,
                state: { entitlementDetails: entitlementDetails, claim: col }
            });
        default:
            // send to ClaimOverview
            pathName = '/DetailsOverview';
            if (typeof propsGlobal?.props.history?.search != 'undefined') {
                pathName += `?id=${propsGlobal?.props.history?.search}`;
            }

            return (history = {
                pathname: pathName,
                claim: col,
                clientId: client,
                state: { claim: col }
            });
    }
}

export const isAppleRoute = () => {
    return (
        window.location.pathname.toLowerCase().includes('apple')
        || window.location.pathname.toLowerCase().includes('file/entitlement')
        || window.location.pathname.toLowerCase().includes('file/payment')
        || window.location.pathname.toLowerCase().includes('file/VerifyInfo')
        || window.location.pathname.toLowerCase().includes('programcoveragedocs')
        || window.location.pathname.toLowerCase().includes('econsent')
        || window.location.pathname.toLowerCase().includes('programsummarydisclosure')
        || window.location.href.toLowerCase().includes('aigtheftandloss')
    );
};

export function createClaimHistoryItem(warrantyObjectId, clientId, eventName, historyNotes) {
    var route = 'api/history/CreateClaimHistoryItem/';
    var finalRoute = route.concat(clientId).concat('/' + warrantyObjectId + '/' + eventName + '/' + historyNotes);

    return fetch(finalRoute, {
        method: 'post'
    });
}

export function getPlanByContractId(contractId, clientId, cookies) {
    var route = 'api/Contract/GetPlanByContractId/';
    var finalRoute = route.concat(contractId).concat('/' + clientId);

    var result = fetch(finalRoute, {
        method: 'Get',
        headers: {
            XSRFTOKEN: cookies.XSRFTOKEN
        }
    })
        .then(function (res) {
            console.log(res);
            let statusCode = res.status;
            let response = null;
            try {
                response = res.json();
            } catch (ex) {
                console.log(ex);
            }

            return response;
        })
        .then((data) => {
            console.log(data);
            //result = data;
            return data;
        });

    return result;
}

export function getMelissaBypassValidation(addressTypeId, clientId) {
    /* TODO */

    var route = 'api/Helper/GetMelissaBypassValidation/';
    var finalRoute = route.concat(addressTypeId).concat('/' + clientId);

    var result = fetch(finalRoute, {
        method: 'Get'
    })
        .then(function (res) {
            console.log(res);
            let statusCode = res.status;
            let response = null;
            try {
                response = res.json();
            } catch (ex) {
                console.log(ex);
            }

            return response;
        })
        .then((data) => {
            console.log(data);
            //result = data;
            return data;
        });

    return result;
}

export async function getClientUrl(clientId) {
    const res = await fetch(`api/helper/GetClientUrl/${clientId}/`);
    const data = await res.json();
    return data;
}

export const getCustomerRedirectUrls = async (clientId) => {
    const res = await fetch(`api/helper/CustomerPortal/RedirectUrls/${clientId}`);
    const data = await res.json();
    return data;
};

export const getTokenExDetails = async (originUrl) => {
    const response = await fetch('api/helper/TokenEx/Details', {
        method: 'Get',
        headers: {
            'Site-Req-OriginUrl': originUrl
        }
    });
    return response;
};
